// Wortlaute der Erklärung „Personalplanung“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Abschnitte stehen so, wie der Kalender sie zeigt (../personnelplanning.js).
export default {
  title: "Personalplanung",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    PersonnelPlanning: "Kalenderliste",
    PersonnelCalendar: "Kalender",
    SettingsOverview: "Abwesenheitsarten",
    ProjectDetail: "Projektphasen",
    EmployeeOverview: "Mitarbeiter",
    TimeTrackingMy: "Meine Zeiten",
    TimeTrackingReview: "Wochenraster",
    // Beide Zeiterfassungsseiten zusammen, als ein Thema auf der Zeitleiste.
    TimeTracking: "Zeiterfassung",
  },
  // Die Seiten außerhalb der Personalplanung, aus denen ein Kalender seine Inhalte bezieht und auf
  // denen die Planung wieder auftaucht.
  related: "Zusammenhänge",
  step: {
    pinned: {
      text: "Angepinnte Kalender stehen oben, alle anderen darunter.",
    },
    "pin-drag": {
      text: "Eine Karte ziehen Sie mit der Maus nach oben zu den angepinnten und genauso wieder nach unten. Die Nadel auf der Karte tut dasselbe mit einem Klick.",
    },
    "card-pin": {
      text: "Die Nadel hält den Kalender oben bei den angepinnten. Das Ebenen-Symbol daneben sagt, dass mehrere Projekte im Kalender liegen.",
    },
    card: {
      text: "Mit diesem Symbol öffnen Sie den Kalender. Schon auf der Karte sehen Sie seinen Namen und als Vorschau, wann seine Projekte laufen.",
    },
    "card-options": {
      text: "Über die drei Punkte benennen Sie den Kalender um.",
    },
    create: {
      text: "Hier legen Sie einen neuen Kalender an. Sie geben ihm einen Namen und wählen seine Projekte.",
    },

    intro: {
      text: "Ein Kalender plant, wer von Ihren Leuten wann auf welcher Baustelle ist. Die Seite hat drei Abschnitte: Projekte, Mitarbeiter und Kapazität.",
    },
    head: {
      text: "Im Menü Aktionen koppeln Sie den Kalender in ein eigenes Fenster ab, benennen ihn um, öffnen die Projektdetails oder löschen ihn.",
    },
    dates: {
      text: "Mit den Pfeilen blättern Sie tageweise, wochenweise oder monatsweise vor und zurück. Heute holt den heutigen Tag zurück in die Ansicht.",
    },
    zoom: {
      text: "Mit den Lupen zoomen Sie heraus und wieder hinein. So passen mehr oder weniger Tage nebeneinander, die mittlere stellt die Ausgangsgröße wieder her.",
    },
    projects: {
      text: "Der Abschnitt Projekte zeigt jedes Projekt des Kalenders als Balken über seine Bauzeit. Das Plus klappt die Phasen auf.",
    },
    employees: {
      text: "Hier stehen die Trupps und Mitarbeitenden des Kalenders mit ihrer Personalrolle. Ein Balken sagt, wer wann auf welchem Projekt ist.",
    },
    capacity: {
      text: "Kapazität stellt den Bedarf dem Personal gegenüber. Geplant ist die Summe aller Phasen, Personal die Zahl der an diesem Tag eingeplanten Leute. Klicken Sie eine Phase in der Legende an, um ihre Linie zu ziehen. Hat der Kalender nur ein Projekt, ziehen Sie gleich die Linie Geplant. Einen ganzen Zeitraum setzen Sie über „Kapazität bearbeiten“ in der Abschnittsleiste. Die Zahlen unter dem Diagramm zeigen Personal minus Geplant: rot heißt, es fehlen Leute.",
    },
    // Die sechs Handgriffe auf dem Brett. Der Zeiger macht sie wirklich, deshalb sagen die Texte,
    // was gerade passiert, und nicht, was man tun könnte.
    mark: {
      text: "Mit gedrückter Maustaste ziehen Sie über die Tage einer Zeile. Die markierten Tage sind der Zeitraum, den Sie gleich verplanen.",
    },
    "menu-days": {
      text: "Die rechte Maustaste auf der Markierung öffnet ihr Menü. Von hier weisen Sie ein Projekt zu oder tragen eine Abwesenheit ein.",
    },
    assign: {
      text: "Ziehen Sie die Markierung auf die Zeile eines Projekts. Die Zeile zeigt vorab, an welchen Tagen wer eingeplant wird, und beim Loslassen ist es so, ganz ohne Formular.",
    },
    move: {
      text: "Einen Balken ziehen Sie in seiner Zeile nach links oder rechts, er rastet tageweise ein. An den Enden ziehen Sie ihn länger oder kürzer.",
    },
    "menu-span": {
      text: "Auch jeder Balken hat sein Menü. Darin ändern Sie die Dauer, weisen ein anderes Projekt zu oder löschen den Einsatz wieder.",
    },
    editor: {
      text: "Zeitstrahl bearbeiten öffnet die beiden Datumsfelder. Die Knöpfe darunter verschieben das Ende, jeder Klick zählt dazu. Speichern übernimmt den neuen Zeitraum, Abbrechen lässt den Balken, wie er ist.",
    },
    "menu-project-row": {
      text: "Auch die Namensspalte öffnet mit der rechten Maustaste ein Menü. Bei einem Projekt zeigen Sie die Vorschau, ändern Zeitstrahl und Farbe oder fügen eine Phase hinzu.",
    },
    "menu-person-row": {
      text: "Bei einer Person öffnen Sie Vorschau oder Detailansicht, weisen ein Team oder Projekt zu und nehmen weitere Mitarbeitende oder Teams in den Kalender auf.",
    },
    resize: {
      text: "Die Linie zwischen zwei Abschnitten ziehen Sie höher oder tiefer. Ein Doppelklick stellt die ursprüngliche Aufteilung wieder her.",
    },
    enlarge: {
      text: "Dieses Symbol gibt einem Abschnitt die ganze Seite. Die anderen bleiben als schmale Leisten stehen und lassen sich wieder aufklappen.",
    },

    again: { text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut." },

    "absence-pick": {
      text: "Eine Abwesenheit tragen Sie auf markierten Tagen über deren Menü ein. Im Fenster wählen Sie die Art, zum Beispiel Urlaub.",
    },
    "absence-types": {
      text: "Die Abwesenheitsarten des Betriebs richten Sie hier ein. Im Kalender wählen Sie daraus, und die Farbe der Art färbt den Balken.",
    },
    "project-phases": {
      text: "Phasen legen Sie am Projekt an. Im Kalender sind sie die Unterzeilen des Projekts, auf die Sie Personal planen.",
    },
    "project-capacity": {
      text: "Der Ø-Bedarf einer Phase sagt, wie viele Leute sie an einem Arbeitstag braucht. Aus diesen Zahlen entsteht die Linie Geplant. Überlappende Phasen addieren ihren Bedarf.",
    },
    staff: {
      text: "Planen können Sie, wer hier als Mitarbeitender steht. Trupps stellen Sie dagegen im Kalender selbst zusammen.",
    },
    "time-suggestion": {
      text: "Wer für heute auf ein Projekt geplant ist, findet es beim Einstempeln schon im Feld. Darunter steht, dass der Vorschlag aus der Planung kommt.",
    },
    "time-absence": {
      text: "Ein ganzer Abwesenheitstag aus dem Kalender erklärt in der Zeiterfassung den leeren Tag. Er steht im Wochenraster als abwesend und gilt nicht als fehlende Zeit.",
    },
  },
}
